import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", { viewBox: _ctx.viewBoxComputed }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icon.paths, (d, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        d
          ? (_openBlock(), _createElementBlock("path", {
              d: d,
              key: index
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ], 8, _hoisted_1))
}